import { z } from 'zod';
import { assetsCurrencyCodeSchema } from './assets-rate.contract.js';
export const assetsFinanceProfitabilityEquipmentCapability = 'assets.finance-profitability-equipment.v1';
export const assetsFinanceProfitabilityEquipmentSlot = 'finance.project-profitability.equipment';
export const assetsFinanceProfitabilityEquipmentProviderId = 'assets.server.finance-profitability-equipment';
export const assetsFinanceProfitabilityEquipmentRequestSchema = z.strictObject({
    consumerModuleId: z.literal('finance'),
    requestedCapability: z.literal('finance.project-profitability.v1'),
    resourceType: z.literal('finance.project-profitability'),
    resourceId: z.string().uuid(),
    asOf: z.string().datetime({ offset: true }),
    projectIds: z.array(z.string().uuid()).min(1).max(500),
}).superRefine((request, context) => {
    if (new Set(request.projectIds).size !== request.projectIds.length) {
        context.addIssue({ code: 'custom', path: ['projectIds'], message: 'Equipment Projects cannot repeat.' });
    }
});
export const assetsFinanceProfitabilityEquipmentProjectSchema = z.discriminatedUnion('state', [
    z.strictObject({
        state: z.literal('present'),
        projectId: z.string().uuid(),
        asOf: z.string().datetime({ offset: true }),
        currencyCode: assetsCurrencyCodeSchema.nullable(),
        activePlacementCount: z.number().int().nonnegative(),
        totalPlacementCount: z.number().int().nonnegative(),
        totalBillablePeriods: z.number().int().nonnegative(),
        equipmentCostCents: z.number().int().nonnegative().max(1_000_000_000_000_000),
    }).superRefine((fact, context) => {
        if (fact.totalPlacementCount === 0 && (fact.activePlacementCount !== 0 || fact.totalBillablePeriods !== 0 ||
            fact.equipmentCostCents !== 0 || fact.currencyCode !== null)) {
            context.addIssue({ code: 'custom', path: [], message: 'Empty equipment facts must be exact zero.' });
        }
        if (fact.totalPlacementCount > 0 && fact.currencyCode === null) {
            context.addIssue({ code: 'custom', path: ['currencyCode'], message: 'Priced equipment needs currency.' });
        }
    }),
    z.strictObject({
        state: z.literal('unavailable'),
        projectId: z.string().uuid(),
        reasonCode: z.enum(['permission-denied', 'project-unavailable', 'cost-basis-incomplete']),
    }),
]);
export const assetsFinanceProfitabilityEquipmentResponseSchema = z.strictObject({
    contractVersion: z.literal(assetsFinanceProfitabilityEquipmentCapability),
    tenantId: z.string().uuid(),
    asOf: z.string().datetime({ offset: true }),
    projects: z.array(assetsFinanceProfitabilityEquipmentProjectSchema).min(1).max(500),
});
//# sourceMappingURL=assets-finance-profitability-equipment.contract.js.map